import { render, staticRenderFns } from "./TopNavMenu.vue?vue&type=template&id=2d39b1b4&"
import script from "./TopNavMenu.vue?vue&type=script&lang=js&"
export * from "./TopNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./TopNavMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports